import React, {PropTypes} from 'react';
import {ajaxGet} from "../../../helpers/apiData";
import {API} from "../../../settings";
import {Link} from "react-router-dom";
import SvgIcons from "../SvgIcons";
import Empty from "./Empty";

class WineFilterList extends React.Component {
  static propTypes = {
    match: PropTypes.object,
    location: PropTypes.object,
    view_info: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      data: null
    };

  }

  componentDidMount() {

    this.lang = this.props.match.params.lang;
    this.restaurant = this.props.match.params.restaurant;
    this.category = this.props.match.params.category;

    this.getData(this.props);
    this.props.view_info(
      '',
      'wines',
      true,
      ''
    );
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.getData(nextProps);
      return false;
    }
    return true;
  }


  getData(props) {
    if (!props.match.params.winetype) {
      ajaxGet(API + this.lang + '/api/' + this.restaurant + '/items/' + this.category + '/wine/', this);
    }
    else {
      ajaxGet(API + this.lang + '/api/' + this.restaurant + '/items/' + this.category + '/wine/' + props.match.params.winetype + '/', this);
    }
  }

  renderItems() {
    if(this.state.data.length === 0){
      return (<Empty/>);
    }

    return this.state.data.map((item) => {
      let url = '/' + this.lang + '/' + this.restaurant + '/wine/' + this.category + '/' + item.id;
      let icon = <SvgIcons icon={"wine-type-"+ item.id}/>;
      
      if (item.id === 4 || item.id === 6){
        url = '/' + this.lang + '/' + this.restaurant + '/items/' + this.category + '/?wine_type=' + item.id ;
      }
      if (this.props.match.params.winetype) {
        url = '/' + this.lang + '/' + this.restaurant + '/items/' + this.category + '/?wine_type=' + this.props.match.params.winetype + '&wine_regions=' + item.id;
        icon = <span style={{"fontSize": 50}}>{item.name[0]}</span>;
      }

      return (
        <div className="list-smallcard-filter" key={item.id}>
          <Link to={url} className="small-card">
            <div className="small-thumb-bg">
              {icon}
            </div>
            <div className="item-content">
              <h4 className="small-item-title">{item.name}</h4>
            </div>
            <div className="arrow">
              <SvgIcons icon="arrow"/>
            </div>
          </Link>
        </div>
      );
    });
  }


  render() {
    return (
      <div className="item-list-filters loaded">
        {this.state.data !== null ? this.renderItems() : null}
      </div>
    );

  }
}

export default WineFilterList;



/** WEBPACK FOOTER **
 ** ./src/components/restaurant/core/WineFilterList.js
 **/